/* eslint-disable no-redeclare */
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'

function useGatsbyImage(fileName: string): IGatsbyImageData | null
function useGatsbyImage(fileName: string[]): (IGatsbyImageData | null)[]
function useGatsbyImage(
  fileName: string | string[],
): (IGatsbyImageData | null) | (IGatsbyImageData | null)[] {
  const data = useStaticQuery(graphql`
    query ImagesQuery {
      allFile(
        filter: {
          dir: { regex: "/src\/assets\/images/" }
          extension: { regex: "/(png|jpg|jpeg)/" }
        }
      ) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)

  if (Array.isArray(fileName)) {
    return fileName.map((name) => {
      const imageNode = data.allFile.edges.find((edge: any) => edge.node.base === name)

      if (imageNode && imageNode.node.childImageSharp) {
        return imageNode.node.childImageSharp.gatsbyImageData
      }
      // Handle case where image is not found
      return null
    })
  }

  const imageNode = data.allFile.edges.find((edge: any) => edge.node.base === fileName)

  if (imageNode && imageNode.node.childImageSharp) {
    return imageNode.node.childImageSharp.gatsbyImageData
  }
  // Handle case where image is not found
  return null
}

export default useGatsbyImage
